import { useEffect, useState } from 'react';
import { site } from '@/mocks/gossip';

interface Props {
  onOpenSearch: () => void;
}

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '图文速递', href: '#feed' },
  { label: '长图合集', href: '#changtu' },
  { label: '明星盘点', href: '#pandian' },
  { label: '小报精选', href: '#xiaobao' },
];

export default function Header({ onOpenSearch }: Props) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header id="top" className="sticky top-0 z-50">
      <div className="bg-primary-500 px-4 py-1.5 text-center text-[11px] tracking-widest text-background-50 md:px-6">
        瓜田速报 · 每日滚动更新中 —— {site.slogan}
      </div>
      <div
        className={`border-b transition-colors ${
          scrolled ? 'border-background-200 bg-background-50/95 backdrop-blur' : 'border-background-200 bg-background-50'
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
          <h1 className="flex items-center gap-2.5 whitespace-nowrap">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-black text-background-50">
                瓜
              </span>
              <span className="hidden flex-col leading-none sm:flex">
                <span className="font-heading text-lg font-black tracking-wide text-foreground-950">{site.brand}</span>
                <span className="mt-1 text-[10px] tracking-[0.2em] text-primary-600">GUATIAN WEEKLY</span>
              </span>
            </a>
          </h1>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-secondary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onOpenSearch}
              aria-label="搜索八卦内容"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-secondary-100 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50"
            >
              <i className="ri-search-line text-base" />
            </button>
            <a
              href="#about"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:inline-block"
            >
              订阅八卦速报
            </a>
            <button
              type="button"
              aria-label={open ? '关闭菜单' : '打开菜单'}
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            >
              <i className={open ? 'ri-close-line text-lg' : 'ri-menu-3-line text-lg'} />
            </button>
          </div>
        </div>

        {open && (
          <nav className="border-t border-background-200 bg-background-50 px-4 py-2 md:hidden" aria-label="移动端导航">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="mt-2 block whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              订阅八卦速报
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}